import { render, staticRenderFns } from "./BasicInformationSectionView.vue?vue&type=template&id=1d0bb713&scoped=true&"
import script from "./BasicInformationSectionView.vue?vue&type=script&lang=js&"
export * from "./BasicInformationSectionView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d0bb713",
  null
  
)

export default component.exports